import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { hardcodedUserIdsForLibSampleCode } from "../../../example1/for_development/const";
export function SurfaceOwnerSelector(props) {
    // const [owners, setOwners] = useState(InkStorage.getInstance().surfaceOwnerIds as string[]);
    // const onSurfaceOwnerAdded = (e: IInkStorageEvent) => {
    //   const owners = InkStorage.getInstance().surfaceOwnerIds ;
    //   setOwners(owners);
    // }
    const owners = hardcodedUserIdsForLibSampleCode;
    const [activeOwner, setActiveOwner] = useState(undefined);
    useEffect(() => {
        // InkStorage.getInstance().
        //   addEventListener(InkStorageEventName.ON_OWNER_ADDED, onSurfaceOwnerAdded, null);
        // return () => {
        //   InkStorage.getInstance().
        //     removeEventListener(InkStorageEventName.ON_OWNER_ADDED, onSurfaceOwnerAdded);
        // }
    }, []);
    const handleOwnerSelected = (e) => {
        let owner = e.target.value;
        if (owner === "*undefined*") {
            owner = null;
        }
        setActiveOwner(owner);
        if (props.changeOwnerFn) {
            props.changeOwnerFn(owner);
        }
    };
    const ownerOptions = owners ? owners.map((owner, index) => {
        if (owner.id === activeOwner)
            return (_jsx("option", Object.assign({ value: owner.id, selected: true }, { children: owner.id ? owner.name : "*undefined*" }), `${index}`));
        else
            return (_jsx("option", Object.assign({ value: owner.id }, { children: owner.id ? owner.name : "*undefined*" }), `${index}`));
    }) : () => { return (_jsx(_Fragment, {})); };
    return (_jsx(React.Fragment, { children: _jsx("ul", Object.assign({ id: "surface-owners" }, { children: _jsx("label", { children: _jsx("select", Object.assign({ title: "select owner", defaultValue: activeOwner, name: "active-owner", id: "owner", onChange: handleOwnerSelected }, { children: ownerOptions })) }) })) }));
}
//# sourceMappingURL=SurfaceOwnerSelector.js.map